var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quantity-input" }, [
    _c(
      "button",
      {
        staticClass: "quantity-input__decrement",
        attrs: {
          label: "Decrease Quantity",
          "aria-label": `Decrease Quantity by 1`
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.decrement.apply(null, arguments)
          }
        }
      },
      [_c("icon", { attrs: { name: "minus", size: "16px" } })],
      1
    ),
    _c(
      "label",
      {
        staticClass: "hidden",
        attrs: { for: "quantity", "aria-hidden": "true" }
      },
      [_vm._v("Quantity")]
    ),
    _c("input", {
      staticClass: "quantity-input__text",
      attrs: {
        id: "quantity",
        name: "quantity",
        type: "text",
        min: _vm.min,
        max: _vm.max,
        "aria-label": `Quantity ${_vm.currentValue}`,
        "aria-live": "polite",
        readonly: ""
      },
      domProps: { value: _vm.quantity }
    }),
    _c(
      "button",
      {
        staticClass: "quantity-input__increment",
        attrs: {
          label: "Increase Quantity",
          "aria-label": `Increase Quantity by 1`
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.increment.apply(null, arguments)
          }
        }
      },
      [_c("icon", { attrs: { name: "plus", size: "16px" } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }